<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M33.362 6.038a1.5 1.5 0 00-2.724 0L22.98 22.631 5.12 25.18a1.5 1.5 0 00-.737 2.647l13.904 11.375-5.063 17.718a1.5 1.5 0 002.229 1.69L32 48.428l16.547 10.183a1.5 1.5 0 002.228-1.69l-5.062-17.718 13.903-11.375a1.5 1.5 0 00-.737-2.646l-17.86-2.551-7.657-16.593zM32 10.246v34.66l.786.483 14.044 8.642-4.273-14.952-.27-.949.763-.624 12.023-9.837-15.285-2.184-.808-.116-.342-.74L32 10.246z"/></svg>